import * as React from 'react';
import Slide from '@material-ui/core/Slide';

type IProps = {
  active: boolean;
  direction: 'left' | 'right' | 'up' | 'down';
  children: React.ReactElement<any, any>;
};

const SlideTransition = (
  { direction, active, children, ...props }: IProps,
  ref: React.ForwardedRef<HTMLElement>
) => (
  <Slide direction={direction} in={active} ref={ref} {...props}>
    {children}
  </Slide>
);

export default React.forwardRef<HTMLElement, IProps>(SlideTransition);
